var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"svg_container"}},[_c('tooltip',{attrs:{"x":_vm.tooltip.x,"y":_vm.tooltip.y,"data":_vm.tooltip.data,"sticky":false},on:{"close-tooltip":_vm.handleEventCloseTooltipClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }